import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentType } from "../enums/_index";

export class ShipmentUpdate {
    
    @ValidateProperty({ required : true })
    public type : ShipmentType;
    
    @ValidateProperty({ required: true })
    public name : string = '';
    
    @ValidateProperty({ required: true })
    public rowVersion : string = '';

    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;

    public note : string|undefined = undefined;

}
